import { Helmet } from 'react-helmet';
import React from 'react';

export default ({ version, date, env }) => (
  <Helmet>
    <meta name="version" content={version} />
    <meta name="date" content={date} />
    <meta name="environment" content={env} />
    <meta name="sanity" content={'active'} />
  </Helmet>
);
